import { useEffect, useState } from "react";
import { get } from "./api";
import { guestBranchId } from './branchPreference';
export default function useCatalog({ q, vendorId, tag, favorites = false, identity, branchId }) {
  const [shuffleSeed] = useState(() => Math.floor(Math.random() * 2147483646) + 1);
  const [refresh, setRefresh] = useState(0);
  useEffect(() => {
    const reload = () => setRefresh((n) => n + 1);
    window.addEventListener("catalog-preference-changed", reload);
    window.addEventListener("favorites-updated", reload);
    return () => {
      window.removeEventListener("favorites-updated", reload);
      window.removeEventListener("catalog-preference-changed", reload);
    };
  }, []);
  const key = JSON.stringify([q, vendorId, tag, favorites, identity, branchId, refresh]);
  const [pages, setPages] = useState({ key: "", productPage: 1, storePage: 1 });
  const productPage = pages.key === key ? pages.productPage : 1;
  const storePage = pages.key === key ? pages.storePage : 1;
  const setPage = (field, value) =>
    setPages((previous) => ({
      ...(previous.key === key ? previous : { productPage: 1, storePage: 1 }),
      key,
      [field]: value,
    }));
  const [result, setResult] = useState({ key: "", data: null, error: "" });
  const requestKey = JSON.stringify([key, productPage, storePage]);
  useEffect(() => {
    const controller = new AbortController();
    const selectedArea = branchId || guestBranchId();
    if (!selectedArea) {
      setResult({ key: requestKey, data: null, error: '' });
      return () => controller.abort();
    }
    const params = new URLSearchParams({
      branchId: selectedArea,
      ...(branchId ? { areaId: branchId } : {}),
      q: q || "",
      vendorId: vendorId || "",
      tag: tag || "",
      favorites: String(favorites),
      shuffleSeed: String(shuffleSeed),
      productPage: String(productPage),
      storePage: String(storePage),
    });
    get("/catalog?" + params, { signal: controller.signal })
      .then((data) => {
        if (!controller.signal.aborted)
          setResult({ key: requestKey, data, error: "" });
      })
      .catch((error) => {
        if (!controller.signal.aborted)
          setResult({
            key: requestKey,
            data: null,
            error: error.response?.data?.message || "Unable to load catalog.",
          });
      });
    return () => controller.abort();
  }, [requestKey, q, vendorId, tag, favorites, productPage, storePage, shuffleSeed, branchId]);
  const current = result.key === requestKey;
  const waitingForArea = !branchId && !guestBranchId();
  return {
    data: current ? result.data : null,
    loading: !current || waitingForArea,
    waitingForArea,
    error: current ? result.error : "",
    productPage,
    storePage,
    setProductPage: (page) => setPage("productPage", page),
    setStorePage: (page) => setPage("storePage", page),
  };
}
